<script setup lang="ts">
// Define page meta for CASL permissions
definePage({
  meta: {
    action: 'read',
    subject: 'License',
  },
})
</script>

<template>
  <div>
    <VCard title="License 🙌">
      <VCardText>This is your second page.</VCardText>
      <VCardText>
        Chocolate sesame snaps pie carrot cake pastry pie lollipop muffin.
        Carrot cake dragée chupa chups jujubes. Macaroon liquorice cookie
        wafer tart marzipan bonbon. Gingerbread jelly-o dragée
        chocolate.
      </VCardText>
    </VCard>
  </div>
</template>
